// extracted by css-extract-rspack-plugin
export default {"reducedIcon":"_34d9a7a2","heartIconWrapperSpacing":"_714a381e","favoritesWrapper":"_56aada99","folderWrapper":"_8039bf48"};